import { render, staticRenderFns } from "./Setting11.vue?vue&type=template&id=e50efa24&"
import script from "./Setting11.vue?vue&type=script&lang=js&"
export * from "./Setting11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports